// extracted by mini-css-extract-plugin
var _1 = "ra-art-bio-curator-thought-avatar";
var _2 = "ra-art-bio-curator-thought";
export { _1 as "artBioCuratorThoughtAvatarCls", _2 as "artBioCuratorThoughtCls" }
